import styles from 'views/PageviewEvent/PageviewEventDropdown.css';
import React from 'react';
import InputText from 'views/widgets/Input/InputText';
import Dropdown from 'views/widgets/Dropdown/Dropdown';
import classnames from 'classnames';

const PageviewEventDropdown = ({
  label,
  dropdown,
  input,
  options,
  onDropdownChange,
  onTextChange,
  borderStyle,
  onClearInput,
  placeholder,
  disabled,
  loading,
  mobileVersion
}) => (
  <div className={classnames(styles.wrapper_dropdown, {[styles.mobileView]: mobileVersion})}>
    <div className={styles.label}>
      {label}
    </div>
    <div className={classnames(styles.select_dropdown, {[styles.mobileActive]: mobileVersion})}>
      <Dropdown
        value={dropdown}
        onChangeKey={onDropdownChange}
        options={options}
        disabled={disabled}
      />
    </div>
    <div className={classnames(styles.input_dropdown, {[styles.mobileLayout]: mobileVersion})}>
      <InputText
        onChange={onTextChange}
        className={styles.no_border_radius_left}
        borderStyle={borderStyle}
        placeholder={placeholder}
        disabled={disabled || dropdown.value === 'EMPTY' || loading}
        value={dropdown.value === 'EMPTY' ? '' : input} />
        {
          dropdown.value !== 'EMPTY' && input && !disabled &&
            <span onClick={onClearInput} className={styles.clear_button}>✕</span>
        }
    </div>
  </div>
);

export default PageviewEventDropdown;



/** WEBPACK FOOTER **
 ** ./src/views/PageviewEvent/PageviewEventDropdown.js
 **/